import { cloneDeep } from "lodash";
import { Form } from "react-bootstrap";
import { InputText } from "../../../../../../components/Inputs";
import { useLang } from "../../../../../../language";

export const SeccionOtrosDatos = ({ formInscripcion, handleInputInscripcion, handleFormInscripcion, isEdit,
  hideGenerarFactura, idpedido }: any) => {

  const Lang = useLang()

  // Funciones helpers

  const handleChangeCheck = (e: any, name: string) => {

    let listaModulosTemp = cloneDeep(formInscripcion[name])

    if (e.target.checked) {

      listaModulosTemp.push(e.target.name)

    } else {

      listaModulosTemp = listaModulosTemp.filter((item: any) => item !== e.target.name)
    }

    handleFormInscripcion({
      ...formInscripcion,
      [name]: listaModulosTemp
    })
  }

  return (
    <>

      {
        idpedido && formInscripcion.observaciones &&
        <Form.Group className="mb-3 col-12">
          <InputText
            label={Lang('OBSERVACIONES_DEL_CLIENTE') + ':'}
            value={formInscripcion.observaciones || '-'}
            readonly={true}
          />
        </Form.Group>
      }

      <Form.Group className="mb-3 col-12">
        <InputText
          label={Lang('OBSERVACIONES_USO_INTERNO') + ':'}
          name='observacionesenvio'
          asParam='textarea'
          rows={3}
          // validation={valuesValidationSeguro}
          value={formInscripcion.observacionesenvio}
          onChange={handleInputInscripcion}
        // fetchData={showModal_Documento.payload.action === 'EDIT' ? fetchPersonaEntidadPATCHData : fetchPersonaEntidadPOSTData}
        />
      </Form.Group>

      {/* {
        !idpedido &&

        <>
          <Form.Group className="mb-3 col-12">
            <div className="row">
              <InputChecks
                name='comunicar'
                value={formInscripcion.comunicar}
                values={[{ id: 'comunicar', nombre: Lang('NOTIFICAR_POR_EMAIL') }]}
                // classNameContainer='col-12 col-lg-6 col-xl-4 mb-3'
                onChange={(e: any) => handleChangeCheck(e, 'comunicar')}
              // fetchData={nuevo ? fetchPersonaPOSTData : fetchPerfilesPATCHData}
              />

            </div>
          </Form.Group>
          <Form.Group className="col-12">
            <div className="row">
              <InputChecks
                name='facturar'
                value={formInscripcion.facturar}
                values={[{ id: 'facturar', nombre: Lang('GENERAR_FACTURA') }]}
                // classNameContainer='col-12 col-lg-6 col-xl-4 mb-3'
                onChange={(e: any) => handleChangeCheck(e, 'facturar')}
              // fetchData={nuevo ? fetchPersonaPOSTData : fetchPerfilesPATCHData}
              />

            </div>
          </Form.Group>
        </>
      } */}

    </>
  )
};
